export const news = [
  {
    id: "chaoxi-shaqing",
    title: "《潮汐之间》正式杀青，吴梦梦一人分饰母女两角",
    category: "行业新闻",
    date: "2026-10-12",
    author: "本刊记者 沈禾",
    excerpt:
      "历时 87 天拍摄，电影《潮汐之间》于上周在海边小城正式杀青。吴梦梦在片中同时饰演母亲与女儿，两个角色跨越二十年，她称之为「一次把自己拆开再拼回去的表演」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20film%20crew%20wrapping%20up%20on%20a%20foggy%20seaside%20pier%20at%20dawn%2C%20deep%20navy%20blue%20water%20and%20warm%20orange%20sunrise%20haze%2C%20camera%20tripod%20silhouettes%2C%20soft%20film%20grain%2C%20documentary%20mood%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-01&orientation=landscape",
    body: [
      "十月十一日凌晨四点，《潮汐之间》的最后一场戏在海边的旧灯塔下完成。这场戏要求女主角在涨潮前走完一段一百二十米的长堤，没有台词，只有一个回头看镜头的动作。导演陈叙喊了三次「过」，最后选用了第一条。",
      "「第三条她在哭，第一条她在忍。」陈叙在杀青采访里说，「这个角色需要的是忍住，不是哭出来。」",
      "影片最大的挑战来自结构。吴梦梦同时饰演母亲和女儿，两个角色在时间线上相差二十年，却共用同一个空间。剧组为此搭了两套完全不同质感的灯塔内景：一套是九十年代的旧木结构，一套是当代的水泥翻新。",
      "「最难的不是演两个人，是演一个人身上留下来的另一个人。」吴梦梦在杀青照里穿着那件贯穿全片的米色风衣说，「拍到最后我发现，其实她们是同一个人，只是被时间劈成了两半。」",
      "影片目前已进入后期制作，预计 2026 年 12 月 24 日全国上映。",
    ],
    relatedWorkId: "chaoxi-zhijian",
  },
  {
    id: "anxiang-yingping",
    title: "《暗巷回声》影评：在城市的暗面，她演出了光",
    category: "影评",
    date: "2026-09-28",
    author: "特约影评人 何岸",
    excerpt:
      "《暗巷回声》几乎全部发生在夜里，但看完之后留在心里的偏偏是光。吴梦梦饰演的声音分析师，是这部听觉型悬疑片真正的耳朵。",
    cover:
      "https://readdy.ai/api/search-image?query=Neon-lit%20rainy%20city%20alley%20at%20night%20seen%20from%20above%2C%20deep%20navy%20blue%20shadows%20and%20warm%20orange%20streetlamp%20reflections%20on%20wet%20asphalt%2C%20cinematic%20noir%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-02&orientation=landscape",
    body: [
      "如果只用一个词形容《暗巷回声》，我会选「倾听」。这部电影几乎没有传统的追逐段落，它所有的紧张感都来自声音：磁带底噪、空调外机、远处电梯的提示音，以及一段被人为抹掉的三秒钟空白。",
      "吴梦梦饰演的声音分析师周迟，全片有大量戴着耳机的特写。她的表演方法很聪明——不演听不见，而是演「努力听清」。眉头的变化、呼吸的停顿，都是可以被观众读到的信息。",
      "影片最动人的一场戏在四十三分钟：她终于听清了录音里那个被忽略的名字，然后摘下耳机，走到窗边。整场戏没有一句台词，镜头在她背后停了将近一分钟。",
      "当然，影片并不完美。中段关于警局内部流程的支线略显冗长，反派的动机也稍嫌单薄。但这些瑕疵并不妨碍它成为今年最值得在影院里关掉手机看完的电影之一。",
    ],
    relatedWorkId: "anxiang-huisheng",
  },
  {
    id: "dianyingzhan-dashi",
    title: "吴梦梦出任第 26 届亚洲电影展推广大使",
    category: "演员动态",
    date: "2026-09-15",
    author: "编辑部",
    excerpt:
      "第 26 届亚洲电影展组委会今日宣布，演员吴梦梦将担任本届影展推广大使，并携新作《潮汐之间》参与「亚洲新声」单元展映。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20cinema%20gala%20hall%20with%20deep%20navy%20blue%20curtains%20and%20warm%20orange%20stage%20lighting%2C%20empty%20red%20carpet%20leading%20to%20a%20glowing%20screen%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-03&orientation=landscape",
    body: [
      "组委会在公告中表示，选择吴梦梦担任推广大使，是因为她近年的作品「在商业类型与作者表达之间找到了一条自己的路」。",
      "这是吴梦梦首次担任国际影展的推广大使。她将在影展期间参与三场公开活动，包括一场关于「女性角色的复杂性」的大师对谈。",
      "「我不太会做大使该做的事，比如站在台上说很多漂亮的话。」她在接受采访时笑说，「但如果有年轻导演想聊剧本，我可以从早聊到晚，这个我擅长。」",
      "第 26 届亚洲电影展将于 11 月 3 日至 11 月 12 日举行。",
    ],
  },
  {
    id: "changye-kaiji",
    title: "年代剧《长夜将明》开机，吴梦梦首次挑战年代群像",
    category: "行业新闻",
    date: "2026-08-30",
    author: "本刊记者 沈禾",
    excerpt:
      "由许岸执导的年代剧《长夜将明》于 8 月 28 日在江南正式开机。吴梦梦在剧中饰演一名丝厂女会计，这也是她首次出演年代群像剧。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%201930s%20industrial%20textile%20factory%20interior%20with%20warm%20orange%20hanging%20lamps%20and%20deep%20navy%20shadows%2C%20dust%20in%20the%20air%2C%20cinematic%20period%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-04&orientation=landscape",
    body: [
      "《长夜将明》改编自同名长篇小说，以 1930 年代江南丝厂为背景，讲述一群普通工人在时代变动中的选择。全剧共 36 集，预计 2027 年与观众见面。",
      "吴梦梦饰演的女主角沈砚原本只是想守住一份稳定的工作，却因为一本账册被卷入了更大的漩涡。",
      "为了准备这个角色，她在开机前一个月进入剧组做功课，学习珠算、旧式簿记和当时的吴语腔调。",
      "「我最怕的是把她演成一个符号。」吴梦梦在开机仪式上说，「她不是英雄，她只是比别人多问了一句为什么。」",
    ],
    relatedWorkId: "changye-jiangming",
  },
  {
    id: "shanhai-fanying",
    title: "《山海邮局》特别放映会：把信读给海听",
    category: "活动报道",
    date: "2026-08-08",
    author: "现场记者 林岸",
    excerpt:
      "《山海邮局》上映两周年特别放映会日前在海边露天举行，吴梦梦到场与观众一起看完影片，并在映后朗读了观众写下的三十七封信。",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20seaside%20film%20screening%20at%20dusk%20with%20a%20glowing%20screen%20and%20rows%20of%20small%20warm%20orange%20lanterns%2C%20deep%20navy%20blue%20ocean%20and%20twilight%20sky%2C%20cinematic%20documentary%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-05&orientation=landscape",
    body: [
      "放映地点选在电影最初的取景地，一块面对渔港的空地。主办方没有搭台，观众自带椅子和毯子，海风把幕布吹得一直在轻轻晃动。",
      "映后，吴梦梦坐在幕布前的台阶上，读了三十七封观众投进「山海邮筒」的信。有人写给去世的父亲，有人写给十年前的自己。",
      "「拍这部电影的时候我一直觉得它太小了，小到可能没人看。」她说，「今天我发现它不小，它只是安静。」",
      "活动在晚上十点结束，最后一场潮水刚好退去。",
    ],
    relatedWorkId: "shanhai-youju",
  },
  {
    id: "nanfeng-yingping",
    title: "从《南风知我意》看都市女性的柔软与锋利",
    category: "影评",
    date: "2026-07-20",
    author: "特约影评人 何岸",
    excerpt:
      "表面上它是一个爱情故事，实际上它讲的是一整套自我校准的过程。吴梦梦饰演的气象预报员，是近年国产都市剧里少见的不靠情绪推动的角色。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20city%20rooftop%20terrace%20with%20a%20small%20table%20and%20two%20cups%2C%20soft%20orange%20sky%20over%20deep%20navy%20skyline%2C%20intimate%20urban%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-06&orientation=landscape",
    body: [
      "《南风知我意》最好的一点，是它没有把女主角的成长写成一场胜利。",
      "吴梦梦饰演的江迟是一个气象预报员，她的职业习惯是给一切加上概率。剧集用大量细节呈现这种思维：她会在吵架前先想清楚三种可能的结果，会在告白之后立刻计算距离。",
      "但真正让角色立起来的，是那些概率失效的时刻。第二十七集，她在暴雨里站了整整一夜，什么也没算出来——那场戏她几乎没有动作，只是让雨落在脸上。",
      "四十集的长度让这部剧有些地方显得拖沓，但它对一个人如何慢慢学会「不确定也可以」的描写，值得被记住。",
    ],
    relatedWorkId: "nanfeng-zhiwoyi",
  },
  {
    id: "qianshui-xunlian",
    title: "为新角色完成自由潜水训练，吴梦梦：憋气比背台词难",
    category: "演员动态",
    date: "2026-06-25",
    author: "编辑部",
    excerpt:
      "吴梦梦近日在社交平台分享了为期三个月的自由潜水训练记录，静态闭气时间从 1 分 40 秒提升到 4 分 12 秒。",
    cover:
      "https://readdy.ai/api/search-image?query=Underwater%20view%20of%20sunlight%20rays%20piercing%20deep%20navy%20blue%20water%20with%20rising%20bubbles%20and%20a%20distant%20silhouette%2C%20cinematic%20editorial%20photography%2C%20warm%20orange%20light%20hint%20at%20the%20surface%2C%20soft%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-07&orientation=landscape",
    body: [
      "训练记录里，她贴着泳池边漂浮，教练在旁边记录时间。第四条视频里，她从水里出来，第一句话是「我刚刚想到一句台词」。",
      "「憋气比背台词难多了。」她在配文里写道，「背台词你可以重来，憋气不行。」",
      "据工作人员透露，这次训练是为下一部作品做准备，但具体项目暂未公开。",
      "粉丝在评论区里最关心的问题则是另一个：她到底什么时候休息。",
    ],
  },
  {
    id: "niandu-piandan",
    title: "吴梦梦工作室公布年度片单，三部作品风格跨度极大",
    category: "行业新闻",
    date: "2026-05-18",
    author: "本刊记者 沈禾",
    excerpt:
      "片单包含电影《潮汐之间》、年代剧《长夜将明》以及一部尚未命名的小成本文艺片，三部作品分别对应海边、工厂与城市三个空间。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20film%20production%20office%20desk%20with%20three%20stacked%20script%20folders%20and%20a%20warm%20orange%20desk%20lamp%2C%20deep%20navy%20blue%20dusk%20light%20through%20the%20window%2C%20cinematic%20still%20life%2C%20soft%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-08&orientation=landscape",
    body: [
      "片单发布会在工作室的小会议室举行，没有红毯，也没有主持人。吴梦梦自己用投影讲了四十分钟。",
      "三部作品的共同点只有一个：都由她主动争取。「我现在选戏的标准很简单，就是读完之后会不会睡不着。」",
      "关于那部尚未命名的小成本文艺片，她只透露了一句：「预算很少，但我很想拍。」",
    ],
  },
  {
    id: "diqi-yingping",
    title: "《第七个清晨》：一部关于告别的温柔电影",
    category: "影评",
    date: "2026-04-09",
    author: "影评人 苏简",
    excerpt:
      "一个房间，七天，一个女人。陆青导演用极简的设定完成了一次关于失去的完整推演，而吴梦梦的表演是这部电影唯一需要的特效。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20sunlit%20room%20with%20a%20single%20wooden%20chair%20and%20long%20warm%20orange%20morning%20shadows%20across%20the%20floor%2C%20muted%20deep%20navy%20walls%2C%20quiet%20arthouse%20cinema%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-09&orientation=landscape",
    body: [
      "《第七个清晨》的设定简单到可以被一句话说完：一个女人连续七天在同一个清晨醒来，屋子里的东西每天少一件。",
      "但电影真正在做的事，是让观众和她一起做减法。第一天少了一把伞，第三天少了一张照片，第五天少了一整面书架。她开始拿本子记录，而记录本身成了新的失去。",
      "吴梦梦的表演几乎全部由静止构成。她很少哭，最多是坐在床边发呆，手指无意识地摩挲床单的边缘。这种克制让最后一场戏的崩溃显得格外有分量。",
      "如果你最近刚好在告别什么，这部电影可能会让你在片尾字幕亮起时坐很久。",
    ],
    relatedWorkId: "diqi-ge-qingchen",
  },
  {
    id: "juben-langdu",
    title: "《无声证词》剧本朗读会：让沉默先开口",
    category: "活动报道",
    date: "2026-03-21",
    author: "现场记者 林岸",
    excerpt:
      "《无声证词》三周年剧本朗读会在小剧场举行，吴梦梦与手语顾问团队同台，全场以无声开场，持续了两分钟。",
    cover:
      "https://readdy.ai/api/search-image?query=Intimate%20small%20theatre%20stage%20with%20a%20single%20spotlight%20and%20empty%20chairs%2C%20deep%20navy%20blue%20darkness%20with%20warm%20orange%20footlights%2C%20cinematic%20documentary%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20watermark&width=900&height=560&seq=news-10&orientation=landscape",
    body: [
      "朗读会以两分钟的静默开场。演员站在台上，没有台词，只用手语完成了一段对话。",
      "「我们想让在场的人先体验一次听不见的感觉。」吴梦梦在开场白里说，「不用紧张，听不懂是正常的，剧里的角色也花了很久才学会。」",
      "当晚朗读的是剧集第一集与最后一集。两种截然不同的语气，让现场不少观众红了眼眶。",
      "活动结束后，剧组宣布将把手语教学短片免费开放给公众。",
    ],
    relatedWorkId: "wusheng-zhengyan",
  },
];

export const newsCategories = ["全部", "影评", "行业新闻", "活动报道", "演员动态"];